import { FormGroup } from '@angular/forms';
import { PartyDetailDto } from '@opb-workspace/shared';
import { MatOptionSelectionChange } from '@angular/material/core';
import { InstructivoEmbarqueService } from '../../../services/instructivo-embarque.service';
import { partyDetailToContactFormPatch } from './step2-party-contact-patch.util';

export type PartyRole = 'shipper' | 'consignee' | 'notify';

/** Vista mínima del host (el componente paso 2) para mutar opciones y selección. */
export interface Step2PartyUiHost {
    shipperOptions: PartyDetailDto[];
    selectedShipper: PartyDetailDto | null;
}

export function runStep2PartySearch(
    service: InstructivoEmbarqueService,
    role: PartyRole,
    searchTerm: string,
    host: Step2PartyUiHost,
    onHttpError?: (role: PartyRole) => void,
): void {
    if (role !== 'shipper') return;
    const trimmed = (searchTerm ?? '').trim();
    service.searchParties(role, trimmed).subscribe({
        next: (results) => {
            const sel = host.selectedShipper;
            host.shipperOptions =
                sel && !results.some((r) => r.partyId === sel.partyId)
                    ? [sel, ...results]
                    : results;
        },
        error: () => {
            host.shipperOptions = [];
            onHttpError?.(role);
        },
    });
}

export function applyStep2PartySelection(
    form: FormGroup,
    role: PartyRole,
    party: PartyDetailDto,
    host: Step2PartyUiHost,
): void {
    if (role !== 'shipper') return;
    host.selectedShipper = party;
    const displayName =
        (party.shortName ?? '').trim() ||
        (party.name ?? '').trim() ||
        (party.fullName ?? '').trim();
    form.patchValue({
        shipperPartyId: party.partyId,
        shipperName: displayName,
        shipperAddress: party.address,
        ...partyDetailToContactFormPatch('shipper', party),
    });
    host.shipperOptions = [party];
}

/** Evita que deselecciones programáticas de `mat-option` disparen lógica como si fuera el usuario. */
export function isUserPartyOptionSelect(
    ev: MatOptionSelectionChange,
): boolean {
    return Boolean(ev.isUserInput && ev.source.selected);
}

/** Limpia selección de organizaciones para flujo manual (booking externo / sin apply OPB). */
export function clearStep2PartiesForManualFlow(
    form: FormGroup,
    host: Step2PartyUiHost,
): void {
    form.patchValue(
        {
            shipperPartyId: null,
            shipperName: '',
            shipperAddress: '',
            shipperEmail: '',
            shipperTaxIdentificationNumber: '',
            shipperContactName: '',
            shipperPhoneNumber: '',
            shipperMobilePhoneNumber: '',
            customerContactEmail: '',
            customerAttentionContactName: '',
            customerTaxIdentificationNumber: '',
        },
        { emitEvent: false },
    );
    host.selectedShipper = null;
    host.shipperOptions = [];
}
